import { styled, css } from '@vebox/etui-system';
import { b as _extends, d as _objectDestructuringEmpty, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Input, Label } from '@vebox/etui-system-elements';

const FormItem = styled(Div).attrs(_ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return _objectSpread2({
    display: 'block',
    position: 'relative'
  }, props);
})`
  ${Input} {
    ${({
  readOnly
}) => readOnly && css`
        border: 0;
        background-color: transparent;
        cursor: inherit;
        pointer-events: none;
        box-shadow: none;
      `};
  }

  ${Label} {
    ${({
  readOnly
}) => readOnly && css`
        pointer-events: none;
      `};
  }
`;

export { FormItem };
